import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { LogOut, ArrowLeft } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import { api } from "../lib/api";
import { Logo } from "../components/Logo";
import { AdminLogin } from "../components/admin/AdminLogin";
import { AdminGallery } from "../components/admin/AdminGallery";
import { AdminChat } from "../components/admin/AdminChat";
import { AdminSettings } from "../components/admin/AdminSettings";

export default function Admin() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));
  }, []);

  const logout = async () => { await api.post("/auth/logout").catch(() => {}); setUser(false); };

  if (user === null) return <div className="grid min-h-screen place-items-center text-[var(--ink-soft)]">Caricamento...</div>;
  if (!user) return <AdminLogin onLogin={setUser} />;

  return (
    <div data-testid="admin-dashboard" className="min-h-screen">
      <header className="border-b border-[var(--gold)]/20 bg-[var(--cream)]/90 backdrop-blur">
        <div className="mx-auto flex h-[72px] max-w-6xl items-center justify-between px-5">
          <Logo testid="admin-logo" />
          <div className="flex items-center gap-2">
            <Link to="/" data-testid="admin-view-site" className="hidden items-center gap-2 rounded-full px-4 py-2 text-sm hover:bg-white sm:flex"><ArrowLeft size={15} /> Sito</Link>
            <button data-testid="admin-logout-button" onClick={logout} className="flex items-center gap-2 rounded-full border border-[var(--ink)]/20 px-4 py-2 text-sm hover:border-[var(--gold)]"><LogOut size={15} /> Esci</button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-6xl px-5 py-10">
        <p className="eyebrow">Area riservata</p>
        <h1 className="mt-2 font-display text-4xl sm:text-5xl">Ciao, gestisci AURA</h1>
        <Tabs defaultValue="chat" className="mt-10">
          <TabsList className="h-auto flex-wrap rounded-full bg-[var(--blush)] p-1">
            <TabsTrigger data-testid="admin-tab-chat" value="chat" className="rounded-full px-5 py-2">Messaggi</TabsTrigger>
            <TabsTrigger data-testid="admin-tab-gallery" value="gallery" className="rounded-full px-5 py-2">Galleria</TabsTrigger>
            <TabsTrigger data-testid="admin-tab-settings" value="settings" className="rounded-full px-5 py-2">Info & Social</TabsTrigger>
          </TabsList>
          <TabsContent value="chat" className="mt-8"><AdminChat /></TabsContent>
          <TabsContent value="gallery" className="mt-8"><AdminGallery /></TabsContent>
          <TabsContent value="settings" className="mt-8"><AdminSettings /></TabsContent>
        </Tabs>
      </main>
    </div>
  );
}
